export const CAPTCHA_APPEAL_BAN = 'CAPTCHA_APPEAL_BAN';
export const CAPTCHA_VERIFY_NEW_USER = 'CAPTCHA_VERIFY_NEW_USER';
export const CAPTCHA_VERIFY_SUCCESS = 'CAPTCHA_VERIFY_SUCCESS';
export const CAPTCHA_VERIFY_FAILURE = 'CAPTCHA_VERIFY_FAILURE';

export const CAPTCHA_VENDOR_RECAPTCHA = 'recaptcha';
export const CAPTCHA_VENDOR_ARKOSE = 'arkose';

export const CAPTCHA_EXPERIMENT_TYPE_RECAPTCHA = 'CAPTCHA_V1';
export const CAPTCHA_EXPERIMENT_TYPE_ARKOSE = 'CAPTCHA_V2';
export const CAPTCHA_EXPERIMENT_TYPE_NONE = 'CAPTCHA_INVALID';

export const CAPTCHA_REASON_ONBOARDING = 'onboarding';
export const CAPTCHA_REASON_APPEALABLE_BAN = 'challenge';
